export const getDowntimeStartDate = (state) => {
  return state.downtimeStartDate;
};
